// extracted by mini-css-extract-plugin
export default {"body":"style_body__f5ywx","content":"style_content__K5nLZ"};